import * as React from 'react';
import { canUseDOM } from '../../utilities/helpers';

const refreshAddThis = (div: HTMLDivElement, refreshed?: boolean, waitForScriptCount?: number) => {
    const addthis = (window as unknown as any).addthis;
    if (refreshed) {
        setTimeout(() => {
            if (!div.innerHTML) {
                // Content cleared, refresh again
                refreshAddThis(div);
            }
        }, 50)
    } else if (addthis) {
        setTimeout(() => {
            if (!div.innerHTML) {
                if (addthis.layers && addthis.layers.refresh) {
                    addthis.layers.refresh();
                    refreshAddThis(div, true);
                } else {
                    refreshAddThis(div);
                }
            }
        }, 0);
    }
    else if (!waitForScriptCount || (waitForScriptCount <= 50)) {
        setTimeout(() => {
            refreshAddThis(div, false, (waitForScriptCount || 0) + 1);
        }, 50);
    }
};

export default () => {
    const divRef = React.useRef<HTMLDivElement>(null);
    const [initialized, setInitialized] = React.useState(false);

    const isClientSide = canUseDOM();

    React.useEffect(() => {
        const div = divRef.current;

        if (!initialized && isClientSide && div) {
            setInitialized(true);

            const childDiv = document.createElement('div');
            childDiv.className = 'addthis_inline_share_toolbox';
            div.appendChild(childDiv);

            refreshAddThis(childDiv);
        }
    }, [isClientSide, initialized, divRef]);

    return (
        <>
            <div ref={divRef} />
        </>
    );
};
